import { Box, Text } from "@chakra-ui/react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./style.css";

const ScheduleCalendar = ({
  title,
  selectedDate,
  setSelectedDate,
  minDate,
}: {
  title: string;
  selectedDate: Date | null;
  setSelectedDate: React.Dispatch<React.SetStateAction<Date | null>>;
  minDate?: Date | null;
}) => {
  return (
    <Box
      width={"280px"}
      padding={"4px 8px"}
      border={"1px solid #CDD6DC"}
      borderRadius={"12px"}
    >
      <Text mb={2}>{title}</Text>
      <DatePicker
        selected={selectedDate}
        onChange={(date) => setSelectedDate(date)}
        dateFormat="yyyy-MM-dd"
        minDate={minDate || new Date()}
        inline
      />
    </Box>
  );
};

export default ScheduleCalendar;
